import { render, staticRenderFns } from "./WithdrawDialog.vue?vue&type=template&id=58677ff8&scoped=true&"
import script from "./WithdrawDialog.vue?vue&type=script&lang=js&"
export * from "./WithdrawDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58677ff8",
  null
  
)

export default component.exports